import * as React from 'react';
import customIconWrapper from './custom-icons';

const SidelyText = customIconWrapper(
	<>
		<g clipPath="url(#clip0_1801_919)">
			<path
				d="M108.065 43.1459L112.225 33.1528L103.347 10.8076H110.466L115.913 26.0761L121.017 10.8076H128.308L115.441 43.1459H108.065Z"
				fill="#202020"
			/>
			<path
				d="M93.9265 33.3246V1.58667H100.145V33.3246H93.9265Z"
				fill="#202020"
			/>
			<path
				d="M78.8009 33.7104C71.1669 33.7104 66.8352 28.5208 66.8352 22.0875C66.8352 15.5683 71.7244 10.4216 78.8009 10.4216C86.3063 10.4216 90.2949 16.2117 90.2949 22.0875V24.3606H73.1826C73.9975 27.0197 76.1848 28.2635 78.8009 28.2635C82.2319 28.2635 84.0761 26.3764 84.6337 25.2184L89.3513 28.049C88.4936 29.9791 85.1912 33.7104 78.8009 33.7104ZM73.3113 19.4712H83.8188C83.6473 18.1417 82.1891 15.7399 78.7151 15.7399C76.485 15.7399 74.2119 16.9408 73.3113 19.4712Z"
				fill="#202020"
			/>
			<path
				d="M49.9666 33.7106C44.0909 33.7106 38.8157 29.4217 38.8157 22.0877C38.8157 15.011 44.0909 10.4218 49.9666 10.4218C52.8829 10.4218 55.6706 11.6227 56.9573 13.2954V1.58667H63.176V33.3246H56.9573V30.837C55.6706 32.5097 52.8829 33.7106 49.9666 33.7106ZM45.1631 22.0877C45.1631 25.3472 47.5648 27.8777 51.0816 27.8777C54.5127 27.8777 57.0002 25.3472 57.0002 22.0877C57.0002 18.8281 54.5127 16.2976 51.0816 16.2976C47.5648 16.2976 45.1631 18.8281 45.1631 22.0877Z"
				fill="#202020"
			/>
			<path
				d="M28.8032 33.3245V10.8077H35.0219V33.3245H28.8032ZM27.9883 3.81682C27.9883 1.58658 29.6609 -0.000312805 31.8911 -0.000312805C34.1212 -0.000312805 35.7939 1.58658 35.7939 3.81682C35.7939 6.04705 34.1212 7.63394 31.8911 7.63394C29.6609 7.63394 27.9883 6.04705 27.9883 3.81682Z"
				fill="#202020"
			/>
			<path
				d="M12.3093 27.4488C16.7268 27.4488 17.9276 26.0334 17.9276 24.7039C17.9276 23.5459 17.0699 22.6452 15.0541 22.1734L9.90759 20.9296C5.14703 19.7716 1.50156 17.1983 1.50156 12.0516C1.50156 6.39024 6.39078 2.91623 12.6953 2.91623C19.3858 2.91623 22.9026 6.47602 24.1892 10.0358L18.3565 12.8665C17.8847 11.0223 16.2121 8.87781 12.6953 8.87781C9.52159 8.87781 8.06341 10.336 8.06341 11.88C8.06341 13.2096 9.1356 13.9816 10.8082 14.3676L16.9841 15.8687C21.9162 17.0696 24.5752 20.1148 24.5752 24.3179C24.5752 29.0786 20.8869 33.7106 12.0949 33.7106C5.10414 33.7106 1.28712 29.7648 0.000488281 26.5052L5.49013 23.3314C6.34789 25.7761 9.22138 27.4488 12.3093 27.4488Z"
				fill="#202020"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1801_919">
				<rect width="128.664" height="43.318" fill="white" />
			</clipPath>
		</defs>
	</>,
	{ viewBox: '0 -10 129 60' }
);

export default SidelyText;
